var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardLogoJaywan = function SvgCardLogoJaywan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 86,
    fill: "none",
    viewBox: "0 0 64 43"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 41.67,
    x: 0.5,
    y: 0.5,
    fill: "#F9F9FA",
    rx: 6.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 41.67,
    x: 0.5,
    y: 0.5,
    stroke: "#DFE0E5",
    rx: 6.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#card-logo-jaywan_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#003C51",
    d: "M49.558 11.517c.3.17.302.162.592.345l.327.227c1.078.839 1.219 1.064 1.78 1.636l.044.048c.643.704.783.805 1.173 1.099l.053.039c.257.179.387.283.898.496.252.092.238.153 1.51.305.017.1.048 2.439-.015 2.672-.09.01-.088.01-12.74.01-.44 0-1.42.042-2.282-.644-.184-.146-.49-.601-.567-.854-.033-.11-.003-.187-.11-.138-.025.012-.005.024-.155.314-.076.112-.07.111-.141.226-.014.018-.072.106-.374.45a4 4 0 0 1-.457.324c-.51.256-1.031.291-1.07.297l-.33.021c-.546.004-6.461.045-6.832-.018.055-.098.059-.093.61-.64.63-.62.548-.677.832-1.15.884.016 5.028.006 5.11 0 .707-.044.889-.347.986-.501.005-.01 0-.009.062-.13.05-.116.047-.112.088-.232.127-.441.102-.447.105-4.787.088-.083.105-.068 1.525-.068.164 0 .32-.041.32.112.005.613-.005.608.001 2.142.001.436.002.431-.001.866.008.255.01.25.04.503l.002.046c.233 1.492 1.01 1.856 2.073 2.022l.047.002c.66.079 9.302 0 9.993.042.21.013-.085-.15-.098-.157-1.635-1.03-2.477-3.12-4.925-3.687-.548-.127-1.377-.036-1.413-.136-.003-.008-.03-1.537.011-1.732.102-.026.265-.067 1.307.018l.047.002c1.133.173 1.366.319 1.974.61"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003C52",
    fillOpacity: 0.99,
    d: "M45.697 24.94c.271.23.36.344.374.36.053.068.041.072.103.137.09.097.07-.092.07-.102-.002-.058-.02-.657.005-.719.107-.029.184-.021.962-.021.75 0 .76-.021.867.058l.002 6.057c-.067.12-.104.095-1.244.095-.326 0-.511.023-.6-.051-.002-.13-.016-.32.002-.819.001-.012.047-.396-.12-.101-.231.41-.848.802-.934.857l-.092.045-.232.092c-.251.08-.25.066-.508.112l-.236.023c-.026-.001-.02-.006-.045-.008-.03 0-.028 0-.376-.013l-.14-.011-.188-.036c-.019-.005-.016 0-.232-.053-.023-.007-.141-.045-.28-.094-1.402-.61-1.628-1.378-1.877-2.27l-.036-.23-.02-.18c-.002-.04-.003-.04-.018-.502.031-.374.015-.803.377-1.584.009-.016.082-.142.115-.195l.017-.035c.162-.22.159-.218.173-.237l.02-.032a5 5 0 0 1 .463-.45c.017-.014.017-.009.224-.15.022-.015.024-.01.289-.166l.04-.014c.377-.168.701-.23.889-.267l.045-.003c.493-.032.489-.026.98.007 0 0 .659.103 1.161.5l-.2 1.42c-1.044-.992-2.37-.355-2.602.704-.563 2.566 2.384 3.535 3.296.733.103-.314-.357-1.148-.693-1.437z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003C52",
    d: "M14.42 27.204c.077-.328.19-2.152 2.272-2.7.564-.15 1.172-.077 1.313-.067.071.018.268.036.65.185.151.073.256.127.278.139.072.05.068.046.14.09.116.09.111.09.232.18l.185.18c.006.005.002.006.064.077.074.101.074.1.08.11.247.352-.063-.78.201-.802.212-.019 1.467-.003 1.595 0 .01 0 .009 0 .119.02.04.092.014 6.122.014 6.138-.053.043-.059.054-1.68.05-.186 0-.16-.095-.154-.777 0-.043.077-.531-.143-.148-.414.6-.966.84-1.117.906-.026.008-.181.06-.323.101-.06.013-.059.012-.325.056-.034 0-.033.004-.422.021l-.235-.023c-.06-.006-.349-.033-.742-.16-.028-.011-.024-.013-.054-.026l-.137-.052c-.011-.005-.013.001-.135-.057-.024-.013-.224-.122-.29-.164l-.035-.018c-1.267-.964-1.379-1.84-1.355-3.169zl4.712 1.638c.271-.328.637-1.002.565-1.276-.286-1.092-1.383-2.153-2.618-1.49-.98.526-1.216 3.016.503 3.377.606.128 1.008-.137 1.241-.315.123-.101.13-.09.31-.296zM9.498 17.063c-1.11-1.369-.969-1.979-.969-5.54 0-.392-.04-.655.102-.658 1.549-.039 1.594-.022 1.722.027.017.099.015.098.015 1.998 0 1.813-.014 1.816.105 2.275.035.095.033.092.076.189.13.236.109.243.282.457.219.259.277.287.412.381.38.29.747.336.856.36l.047.003c.214.035.212.034 5.44.033.16 0 1.437.135 2.127-1.045.156-.265.201-.444.233-.599l.004-.045c.026-.117.023-.112.038-.23.004-3.629-.008-3.626.01-3.775.23-.058 1.769-.038 1.802-.005.059.058.001 2.274.031 3.733-.03.352-.091 2.467-2.458 3.479-.365.156-.994.255-1.083.268l-.377.021c-5.856.046-6.05-.007-6.555-.143a3 3 0 0 1-.375-.132c-.467-.23-.467-.227-.52-.26-.026-.015-.306-.194-.315-.2-.26-.211-.361-.292-.605-.542z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003C52",
    fillOpacity: 0.99,
    d: "M29.776 24.58c.031.005.028.014.091.015 1.663.005 1.68-.03 1.81.063.019.039.017.038.067.172l.037.095c.064.164.06.162.13.324.143.372.14.373.153.405l.077.188c.064.165.059.163.064.176l.078.188c.063.166.058.163.063.177l.078.188c.063.164.058.162.064.176l.077.188c.144.374.141.374.154.406.064.164.06.161.129.323.144.373.14.373.153.406l.066.219c.058.169.13-.115.134-.13.008-.028.077-.29.098-.362.143-.459.136-.457.27-.915l.01-.043c.12-.388.114-.387.229-.776q.005-.022.009-.043c.051-.162.047-.158.094-.32.044-.137.043-.135.083-.276l.01-.043c.093-.3.089-.297.177-.595l.01-.043c.012-.02.012-.145.176-.148h.938c.817 0 .848-.036.963.106l.009.043c.041.142.04.137.084.276.008.032.034.14.113.404l.074.234c.06.205.055.206.061.224.041.142.04.138.084.276.106.34.085.343.196.681.04.14.04.138.083.277.097.333.093.333.102.362.042.14.04.136.086.276l.008.043c.042.141.04.137.084.276l.008.043c.016.056.017.115.032.17.062.218.185-.237.213-.311l.013-.04c.112-.28.11-.276.218-.554l.013-.04c.138-.346.135-.341.27-.689l.013-.04.218-.553.038-.094c.017-.043.011-.041.027-.082l.128-.323c.298-.771.296-.77.35-.902.117-.085.13-.063.965-.063.81 0 .808.005.935-.015l.096-.03c.082-.013.025.034-.02.098-.231.553-2.306 6-2.371 6.108-.056.092-1.822.05-1.949.027l-.76-2.49c-.045-.165-.044-.16-.093-.32-.046-.163-.044-.159-.094-.319-.048-.16-.046-.156-.096-.318-.045-.162-.044-.158-.091-.32-.058-.197-.043-.248-.098-.214-.031.02-.023.024-.03.06l-.033.154c-.09.29-.082.289-1.083 3.645-.152.237-.214.143-.5.143-1.418 0-1.454.023-1.532-.1l-.052-.134c-.134-.367-.13-.365-.281-.729-.135-.369-.13-.367-.282-.73-.032-.087-.232-.636-.422-1.093-.135-.37-.13-.367-.281-.729-.136-.372-.137-.366-.282-.73-.067-.183-.058-.181-.128-.324-.072-.204-.069-.201-.153-.404a29 29 0 0 0-.423-1.094l-.014-.041c.013-.067.01-.065.055-.116"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003C52",
    d: "M25.508 33.286h-1.969c-.005-.08-.018-.079.009-.156l.014-.04c.068-.14.065-.138.128-.278.005-.01 0-.011.056-.134.167-.343.156-.343.312-.69l.014-.04c.213-.439.282-.625.413-.915l.013-.04c.137-.292.051-.3-.063-.603-.172-.456-1.341-3.558-2.167-5.695.019-.108.01-.106.012-.115h.042c.437.069 1.692-.072 1.902.078.114.286 1.046 2.617 1.365 3.598.016.021.009.053.025.075.004.006.053.073.092-.028.02-.052.074-.19.279-.642l.014-.04c.169-.344.158-.343.315-.69l.014-.04c.189-.38.822-1.81.873-1.92l.013-.04c.126-.256.119-.256.132-.276.09-.137 1.567-.01 1.955-.076.056.066.056.078-.016.244-.938 2.058-1.021 2.288-1.167 2.6-.053.112-.05.108-.099.225l-.228.505c-.053.111-.05.108-.099.225-.811 1.777-1.047 2.343-1.167 2.6-.053.111-.05.108-.099.226-.873 1.908-.88 1.904-.918 2.082M54.845 24.706c.496.283.646.6.734.73.231.422.29.823.328 1.039.051.567.044.564.044 2.276 0 1.944.006 1.947-.032 2.037-.108.021-.107.017-1.114.017-.528 0-.568.025-.687-.052-.013-1.106.01-3.41-.014-3.734-.12-1.62-1.587-1.05-1.796-.933-.102.055-.57.306-.954 1.078-.175.351-.146.366-.146 1.86 0 1.707.021 1.777-.106 1.78-1.567.042-1.608.018-1.727-.05-.001-.02-.026-6.046.013-6.138.073-.013.07-.023 1.667-.021.208 0 .172.216.142.783-.01.185.138-.031.144-.04.056-.078.053-.077.058-.084.16-.173.274-.275.512-.449l.035-.017c.113-.07.306-.158.333-.17.248-.101.25-.083.512-.142l.188-.036.14-.008c.424-.011.419-.011.84.002.458.091.462.074.886.272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003C52",
    fillOpacity: 0.99,
    d: "M8.627 28.945c.13.072.941.522 1.835.404.77-.118 1.036-.556 1.097-1.189.004-2.083-.003-4.423.003-5.513.112-.083.125-.081 1.759-.057.007 0 .006.001.085.015.03.091.078 5.539-.029 6.057-.291 1.422-1.152 1.818-1.747 2.087l-.28.092c-.235.06-.232.053-.467.099l-.235.034-.187.007-.328-.001-.326-.014-.19-.03c-.282-.046-.28-.038-.556-.108-.236-.073-.347-.116-.377-.127-.01-.005-.01.003-.137-.052-.343-.166-.431-.237-.464-.264-.006-.063-.008-.061.004-.125.262-.797.26-.796.283-.865.09-.268.095-.457.257-.45M46.51 19.865c.166-.16.173-.148.38-.255.06-.019.058-.017.183-.047.386-.015 1.008-.034 1.241.895l.006.135c-.033.195.001.324-.288.708-.153.124-.149.122-.315.227-.256.096-.281.077-.413.093l-.235-.017c-.93-.271-1.1-1.09-.56-1.739M36.585 20.323c.008-.023.066-.182.124-.278l.018-.035c.63-.776 1.834-.603 1.936.628-.005.024.002.02-.003.045l-.048.223c-.02.044-.063.16-.236.395-.187.184-.451.274-.495.289-.163.02-.16.02-.326.03-.61-.08-.829-.338-.984-.845-.01-.184-.01-.18-.002-.365zM39.02 20.502l.03-.184.011-.042c.069-.152.056-.155.138-.274l.018-.033c.475-.527 1.455-.758 1.883.4l.005.044c.01.18.005.178 0 .36-.08.23-.066.235-.196.442l-.044.048c-.127.125-.126.121-.273.225-.216.11-.22.1-.46.133-.142-.008-.139-.012-.281-.02-.816-.242-.82-.793-.831-1.099"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003C52",
    d: "M14.774 10.932c.406-.126.892-.178 1.336.465.024.07.403.75-.299 1.319-.59.477-1.22.033-1.304-.027-.6-.569-.39-1.22-.043-1.558.132-.099.122-.107.31-.199"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CB9D2B",
    fillOpacity: 0.99,
    d: "m27.057 10.895.278-.028c.405-.002 4.989-.031 5.068.01.063.034.055.055.055 2.833 0 2-.001 2.05.004 2.19l-.007.227c-.025.065-.035.06-.026.13-.005.023-.007.019-.09.276l-.035.048c-.283.474-.202.53-.83 1.152-.553.546-.557.542-.612.639-.186.201-.175.206-.851.856-.222.213-.255.253-.275.278-.017.019-.041.005-.052.088-.08.01-.068.032-.09.051-.01.006-.003.008-.092.089l-.044.05c-.014.013-.044-.009-.055.084-.087.01-.07.037-.086.053l-.046.046-.047.046-.047.045-.047.046-.047.045-.093.092-.047.046-.047.045-.047.046-.046.045-.047.046-.047.046-.047.045-.047.046-.046.045-.047.046-.047.046-.046.046-.047.046-.047.045c-.017.016-.036 0-.06.08-.526.514-.582.645-.798.648-2.43.026-2.656.05-2.52-.094.005-.006.006-.002.076-.06.078-.01.083-.014.096-.09.095-.012.072-.042.084-.055l.094-.091c.018-.018.043-.002.055-.082.103-.035.119-.012.179-.1.006-.009 1.653-1.633 1.693-1.682.004-.005 0-.006.002-.088.11-.004.08-.046.087-.053l.047-.045.047-.046.047-.046.047-.045.047-.046.047-.045.047-.046.046-.045.047-.046.047-.046.047-.045.047-.046.047-.045.093-.092.047-.045.047-.046c.02-.02.043-.004.055-.082.102-.036.11-.02.18-.099.093-.105 1.681-1.658 1.739-1.728.004-.006 0-.007.002-.09l.09-.002c.012-.012-.014-.037-.002-.049l.046-.045.046-.046.048-.043.054-.04c.08-.2.21-.242.16-.493.05-.228.035-.23.022-2.922-.001-.15-.078-.121-.13-.121-2.972-.026-3.01-.003-3.23.13-.103.061-.108.049-.19.13l-.09.053c-.13.103-.393.411-.425.449l-.084.055-.048.045-.046.046-.057.081-.082.057-.047.046-.059.079c-.077.075-.069.077-.956.94-.195.19-.221.172-.328.419-.024.057-.201.468.027.777.033.098.014.108.095.179l.047.044c.01.01-.012.034 0 .045l.087.005c.005.078 0 .08.005.085.011.01.036-.01.047 0l.045.045.046.046c.22.115.228.098.316.071l.008.021c.019.004.028.03.047.034.134.029 3.09.024 3.14.004.008-.003.007-.004.089-.05.08.08.11.112.008.165a205 205 0 0 0-1.362 1.319c-.071.07-.07.064-.133.141l-.053.089c-.077.009-.079.005-.083.01-.019.018.015.025-.003.043l-.047.045-.049.047-.056.04c-1.83.013-2.175.019-2.578-.148a2.3 2.3 0 0 1-.335-.17c-.02-.016-.005-.033-.09-.052l-.05-.039c-.004-.002-.012-.068-.138-.097-.016-.013-.134-.12-.145-.131l-.051-.043c-.011-.01.01-.035 0-.046-.006-.005-.007 0-.088-.006-.008-.088-.037-.073-.052-.09-.006-.008-.04-.05-.086-.095-.014-.072-.015-.08-.091-.093l-.01-.04c-.015-.024.002-.058-.012-.083-.003-.005-.006 0-.072-.014l-.01-.04-.047-.092-.048-.09c-.007-.05-.01-.047-.047-.138l-.053-.088c-.054-.115-.03-.121-.091-.23-.005-.076-.01-.073-.045-.139l-.02-.01c.021-.09.016-.089-.024-.175l-.003-.09c.003-.162-.03-.154-.045-.184v-.456c.007-.018.07-.006.044-.231l.003-.044.054-.136c.126-.377.126-.396.148-.454l.084-.186.045-.093.048-.09.052-.09c.081-.131.152-.222.167-.24.029-.037-.013-.048.014-.082.005-.006.02.02.083-.054.038-.045.017-.056.116-.166.044-.049.043-.046.087-.097.037-.075.048-.067 1.482-1.477.116-.114.157-.099.156-.258h.093c.012-.012-.015-.038-.003-.05l.046-.045.047-.046.047-.045.047-.046.047-.045c.012-.011.037.013.05.002.004-.005 0-.007.001-.09.207.004.209-.113.237-.135.066-.054.078-.03.149-.08.052-.037.235-.166.745-.324.016-.002.012-.004.19-.037"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC9E2B",
    fillOpacity: 0.97,
    d: "M25.627 9.336c-.03.939.03.94-.03 1.227-.096.028-.07.051-.078.06-.012.01-.11.095-.141.132l-.045.05-.058.081-.082.056-.047.046-.094.091-.058.08c-1.233 1.193-1.212 1.21-1.325 1.308-.12.104-.094-.056-.095-1.173.122-.153 1.69-1.667 1.693-1.692.002-.007 0-.006 0-.09l.093-.002c.012-.011-.014-.037-.002-.048l.047-.045.045-.048a.36.36 0 0 1 .177-.033"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00384C",
    fillOpacity: 0.17,
    d: "M24.498 30.993c-.035-.137.04-.142-.007-.28-.093-.273-.12-.257-.127-.28-.378-1.152-.435-1.132-.468-1.232-.106-.326-.098-.328-.108-.356-.07-.197-.107-.177-.173-.373-.424-1.27-.788-2.07-.972-2.587-.394-1.104-.433-1.1-.396-1.237l.021.048a883 883 0 0 1 2.167 5.694c.115.303.2.311.063.603"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00374B",
    fillOpacity: 0.16,
    d: "M52.308 26.086c-.142.284-.311.158-.735.85-.388.634-.307.67-.307 1.405 0 2.473.011 2.515-.07 2.53-.084.014-1.596 0-1.735 0-.162-.002-.087-.104-.086-.117.12.068.16.091 1.727.05.128-.003.106-.073.106-1.78 0-1.494-.03-1.51.146-1.86.385-.772.852-1.023.954-1.079"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003C52",
    fillOpacity: 0.23,
    d: "m56 30.848-.08-.06c.037-.09.032-.092.032-2.037 0-1.712.007-1.709-.045-2.276l.093-.048z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BD9227",
    fillOpacity: 0.15,
    d: "M28.787 16.513c-.082.047-.081.047-.089.05-.05.02-3.006.025-3.14-.004-.02-.004-.028-.03-.047-.033 2.484-.01 3.035.01 3.276-.013"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003B51",
    fillOpacity: 0.24,
    d: "m56 18.45-.08-.067c.064-.232.033-2.572.014-2.671L56 15.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003548",
    fillOpacity: 0.18,
    d: "M39.925 17.298c.016.079.021.079.018.085-.15.23-.143.244-.392.364.302-.343.36-.431.374-.449"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003951",
    fillOpacity: 0.16,
    d: "M8.684 30.701c.03.011.14.054.377.127-.086.037-.084.058-.14.037-.29-.106-.236-.162-.237-.164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003C51",
    fillOpacity: 0.15,
    d: "m10.133 30.98.328.001c-.006.008-.019.07-.094.072-.019 0-.222.005-.237-.018-.01-.015.013-.04.003-.055"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B58C26",
    fillOpacity: 0.18,
    d: "M26.918 10.861c.136-.04.134-.027.277-.03.072.011.07.009.14.036l-.278.028c-.072-.014-.07-.012-.14-.034"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003C51",
    fillOpacity: 0.14,
    d: "m8 30.21.087.05c-.013.063-.01.061-.004.125L8 30.437z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00364A",
    fillOpacity: 0.21,
    d: "M40.066 17.072c-.001.018.028.03.027.048-.01.134-.045.12-.168.178.07-.115.065-.114.141-.226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003143",
    fillOpacity: 0.26,
    d: "M38.025 18.37c-.123.12-.244.054-.33.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003548",
    fillOpacity: 0.24,
    d: "M11.63 30.749c-.089.07-.073.147-.28.092.022-.007.14-.045.28-.093"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00364A",
    fillOpacity: 0.22,
    d: "M26.525 30.979c.064.182-.033.157-.099.225.049-.118.046-.114.099-.226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00374B",
    fillOpacity: 0.22,
    d: "M28.118 27.423c.047.133.008.133-.099.226.049-.118.046-.114.1-.226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B78E26",
    fillOpacity: 0.17,
    d: "m25.186 16.434.093-.001c.115.035.11.04.223.072-.087.026-.096.044-.316-.071"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00374B",
    fillOpacity: 0.24,
    d: "M27.791 28.153c.018.095.022.094.02.102-.05.129-.096.1-.119.123.048-.117.046-.114.1-.225"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003652",
    fillOpacity: 0.2,
    d: "m9.618 30.937.189.03c-.089.037-.088.039-.096.04-.127.015-.092-.068-.093-.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003447",
    fillOpacity: 0.28,
    d: "M10.883 30.94c-.104.074-.11.078-.235.033z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC8726",
    fillOpacity: 0.15,
    d: "M22.822 15.302c.026.226-.037.213-.044.23.007-.133-.022-.138.044-.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A88223",
    fillOpacity: 0.22,
    d: "M22.915 16.587c.06.11.037.116.09.23-.015-.018-.03-.01-.108-.195z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B18728",
    fillOpacity: 0.15,
    d: "m22.85 15.037.03.085-.055.137c.004-.068-.02-.067.025-.222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B08825",
    fillOpacity: 0.14,
    d: "m23.24 14.112.016.098-.052.09-.008-.096c.017-.05.016-.048.045-.092"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE8625",
    fillOpacity: 0.16,
    d: "m23.196 14.204.008.095-.048.09-.006-.093c.017-.05.015-.047.046-.092"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD8524",
    fillOpacity: 0.17,
    d: "m23.15 14.296.006.094-.045.092-.008-.095c.018-.052.017-.049.047-.091"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A88223",
    fillOpacity: 0.1,
    d: "m30.376 16.121.002.093-.054.04-.04.004c.052-.065.035-.072.092-.137"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A17D22",
    fillOpacity: 0.18,
    d: "M22.778 15.99c.015.03.048.021.045.184-.057-.082-.037-.087-.045-.184"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9F7B21",
    fillOpacity: 0.2,
    d: "m23.006 16.817.053.088.007.09c-.065-.075-.049-.08-.06-.178"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB8423",
    fillOpacity: 0.17,
    d: "M22.87 16.449c.034.066.04.062.045.138l-.018.035c-.025-.087-.019-.084-.027-.173"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC8523",
    fillOpacity: 0.18,
    d: "M22.825 16.263c.041.087.046.085.026.176-.026-.089-.019-.087-.026-.176"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E7B21",
    fillOpacity: 0.18,
    d: "M23.818 17.906c.126.03.134.095.137.098-.083-.029-.075-.038-.137-.098"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A58022",
    fillOpacity: 0.07,
    d: "m25.69 11.517-.005.041-.047.046-.042.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A68023",
    fillOpacity: 0.12,
    d: "M25.141 16.388c.077.008.077.003.139.045h-.094z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A07C21",
    fillOpacity: 0.13,
    d: "M23.305 17.402c.076.013.077.021.09.093-.05-.047-.046-.044-.09-.093"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9B7820",
    fillOpacity: 0.13,
    d: "M28.175 18.356c-.012.078-.035.063-.055.082l-.038.009z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9A7720",
    fillOpacity: 0.13,
    d: "M25.362 21.135c-.012.08-.037.065-.055.082l-.037.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#967420",
    fillOpacity: 0.16,
    d: "M23.211 17.265c.066.014.069.01.072.015.014.024-.003.058.011.082z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#997720",
    fillOpacity: 0.11,
    d: "M25.129 21.363c-.013.077-.018.081-.096.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9C7920",
    fillOpacity: 0.24,
    d: "M23.06 16.906c.036.09.04.087.046.137l-.04-.048z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B38A26",
    fillOpacity: 0.06,
    d: "m25.315 9.466.043-.004c-.012.012.014.037.002.048l-.092.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B28A26",
    fillOpacity: 0.06,
    d: "m25.408 11.79.042-.004c-.012.012.016.038.004.05h-.093z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B38B26",
    fillOpacity: 0.06,
    d: "m25.362 9.42.043-.003-.047.045-.044.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B18A26",
    fillOpacity: 0.07,
    d: "m25.455 11.745.043-.004-.047.045-.043.004zM25.502 11.7l.042-.005-.047.046-.042.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B38B26",
    fillOpacity: 0.06,
    d: "m25.409 9.375.041-.005-.045.047-.043.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B38B25",
    fillOpacity: 0.07,
    d: "M25.736 11.471c-.002.082.003.084-.002.089-.011.011-.037-.013-.049-.002l.005-.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B18A26",
    fillOpacity: 0.07,
    d: "m25.55 11.654.041-.005-.047.046-.042.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B28A25",
    fillOpacity: 0.07,
    d: "m25.596 11.609.042-.005-.047.046-.042.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C792E",
    fillOpacity: 0.16,
    d: "m26.364 13.54.036-.01-.094.09.011-.035z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B08825",
    fillOpacity: 0.08,
    d: "m30.143 16.394.04-.006c-.011.012.015.037.003.048l-.09.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B08825",
    fillOpacity: 0.08,
    d: "m30.19 16.349.04-.007-.047.046-.04.006z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF8724",
    fillOpacity: 0.08,
    d: "m27.284 19.22.04-.007c-.008.007.022.049-.087.053z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF8825",
    fillOpacity: 0.09,
    d: "m27.33 19.174.04-.006-.047.045-.04.007z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B18925",
    fillOpacity: 0.07,
    d: "m24.957 16.207.04.005.047.045-.087-.004c-.012-.011.01-.035 0-.046"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF8825",
    fillOpacity: 0.09,
    d: "m27.378 19.129.039-.007-.047.045-.04.007z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B18925",
    fillOpacity: 0.07,
    d: "m25.044 16.257.047.046.005.04c-.011-.011-.036.01-.047 0-.005-.006 0-.007-.005-.086"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF8724",
    fillOpacity: 0.09,
    d: "m27.425 19.083.039-.007-.047.046-.04.007z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF8925",
    fillOpacity: 0.09,
    d: "M23.534 17.68c.08.006.082.002.087.006.012.011-.01.036.001.046l-.04-.006z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#95741F",
    fillOpacity: 0.18,
    d: "m26.13 13.769.036-.011-.094.09.059-.079"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B08825",
    fillOpacity: 0.08,
    d: "m30.237 16.303.04-.006-.047.045-.04.007z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF8724",
    fillOpacity: 0.09,
    d: "m27.471 19.038.04-.007-.047.045-.04.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF8724",
    fillOpacity: 0.09,
    d: "m27.518 18.993.04-.008-.047.046-.04.007z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93721F",
    fillOpacity: 0.19,
    d: "m25.052 11.08.035-.012-.093.091z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF8724",
    fillOpacity: 0.1,
    d: "m27.565 18.947.04-.007-.047.045-.04.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF8825",
    fillOpacity: 0.1,
    d: "m27.612 18.901.04-.007-.047.046-.04.007z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92701E",
    fillOpacity: 0.18,
    d: "m28.335 20.88.034-.012-.093.091c.023-.08.043-.063.059-.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF8825",
    fillOpacity: 0.1,
    d: "m27.66 18.856.038-.007-.046.045-.04.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF8724",
    fillOpacity: 0.1,
    d: "m27.706 18.81.04-.007-.047.046-.04.007z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF8724",
    fillOpacity: 0.11,
    d: "m27.753 18.765.04-.008-.048.046-.039.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B08825",
    fillOpacity: 0.08,
    d: "m24.91 16.163.04.004.047.045-.04-.005z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF8724",
    fillOpacity: 0.11,
    d: "m27.8 18.72.039-.008-.047.045-.039.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF8624",
    fillOpacity: 0.1,
    d: "m29.458 19.783-.008.039-.047.046c.01-.093.04-.07.055-.085"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B08B24",
    fillOpacity: 0.11,
    d: "m27.247 18.227-.047.046-.04.007c.02-.018-.015-.025.004-.043.004-.005.006 0 .083-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE8724",
    fillOpacity: 0.11,
    d: "m27.847 18.674.039-.008-.047.046-.039.007z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A78223",
    fillOpacity: 0.18,
    d: "M32.455 16.127c-.008.067-.007.064-.026.13-.01-.07.001-.065.026-.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF8725",
    fillOpacity: 0.1,
    d: "m30.284 16.258.04-.005-.048.044-.039.006z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF8825",
    fillOpacity: 0.1,
    d: "M25.09 16.303c.037.037.035.035.051.085l-.045-.046z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE8724",
    fillOpacity: 0.11,
    d: "m27.894 18.629.039-.008-.047.045-.039.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD8524",
    fillOpacity: 0.1,
    d: "M23.482 17.59c.016.018.044.002.052.09-.035-.041-.034-.039-.052-.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE8624",
    fillOpacity: 0.11,
    d: "m27.941 18.583.039-.008-.047.045-.039.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE8524",
    fillOpacity: 0.11,
    d: "m29.403 19.868-.047.045-.039.008c.017-.016 0-.043.086-.053"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD8624",
    fillOpacity: 0.12,
    d: "m27.988 18.538.038-.009-.046.046-.039.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD8424",
    fillOpacity: 0.11,
    d: "m29.317 19.921.039-.008-.047.046-.039.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC8524",
    fillOpacity: 0.12,
    d: "m25.176 21.318.037-.009c-.012.012.01.042-.084.054zM28.035 18.492l.038-.009-.047.046-.038.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC8424",
    fillOpacity: 0.11,
    d: "m29.27 19.967.038-.008-.046.045-.038.009z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8226",
    fillOpacity: 0.11,
    d: "m27.161 18.28.04-.008-.049.045-.038.009z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB8424",
    fillOpacity: 0.13,
    d: "m28.082 18.447.038-.009-.047.046-.038.008zM25.223 21.272l.037-.009-.047.046-.038.009z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB8324",
    fillOpacity: 0.12,
    d: "m29.224 20.012.038-.008-.047.045-.038.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A98225",
    fillOpacity: 0.13,
    d: "m27.114 18.326.038-.009-.047.045-.04.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB8323",
    fillOpacity: 0.12,
    d: "m29.177 20.058.038-.009-.047.046-.038.009z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB8524",
    fillOpacity: 0.11,
    d: "m23.581 17.726.041.006.051.043c-.052-.017-.05-.016-.092-.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8323",
    fillOpacity: 0.13,
    d: "m25.27 21.227.037-.01-.047.047-.037.009z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8223",
    fillOpacity: 0.12,
    d: "m29.13 20.104.038-.01-.047.046-.038.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB8323",
    fillOpacity: 0.11,
    d: "M29.736 19.505c-.018.053-.018.049-.052.09.01-.084.035-.07.052-.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A98223",
    fillOpacity: 0.13,
    d: "m29.083 20.15.038-.01-.047.046-.037.009z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8323",
    fillOpacity: 0.11,
    d: "M29.684 19.594c-.042.034-.038.033-.09.051.022-.02.01-.04.09-.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A88123",
    fillOpacity: 0.13,
    d: "m29.037 20.195.037-.01-.047.046-.037.01q.022-.024.047-.046"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A78123",
    fillOpacity: 0.14,
    d: "m28.99 20.24.037-.009-.047.046-.037.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA8523",
    fillOpacity: 0.13,
    d: "M27.3 18.139c-.018.05-.018.046-.053.088z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A78023",
    fillOpacity: 0.14,
    d: "m28.943 20.287.037-.01-.047.045-.037.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A78023",
    fillOpacity: 0.14,
    d: "m28.896 20.332.037-.01-.047.046-.037.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A98123",
    fillOpacity: 0.12,
    d: "M29.502 19.733c-.018.05-.019.048-.052.088l.008-.038z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A88520",
    fillOpacity: 0.15,
    d: "m26.495 13.44-.047.045-.037.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A67F23",
    fillOpacity: 0.14,
    d: "m28.85 20.377.036-.01-.047.046-.037.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC8524",
    fillOpacity: 0.16,
    d: "M25.598 10.564c-.033.038-.03.04-.08.059.009-.008-.017-.032.08-.06"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A57F22",
    fillOpacity: 0.15,
    d: "m28.803 20.423.036-.01-.047.046-.036.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A17B24",
    fillOpacity: 0.17,
    d: "m27.065 18.372.04-.01c-.044.035-.041.034-.096.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A47E22",
    fillOpacity: 0.16,
    d: "m28.756 20.469.036-.01-.047.045-.036.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#988432",
    fillOpacity: 0.16,
    d: "m26.41 13.495.038-.01-.048.045-.037.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A37E22",
    fillOpacity: 0.16,
    d: "m28.71 20.514.035-.01-.047.045-.036.011z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A47F23",
    fillOpacity: 0.17,
    d: "m25.333 10.804-.01.036-.048.046z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A37D22",
    fillOpacity: 0.16,
    d: "m28.662 20.56.036-.01-.047.045-.036.01zM28.615 20.606l.036-.01-.047.045-.035.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A27D22",
    fillOpacity: 0.17,
    d: "M24.006 18.043c.085.018.07.036.09.052-.052-.018-.048-.017-.09-.052"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A27D22",
    fillOpacity: 0.16,
    d: "m28.569 20.651.035-.01-.047.045-.035.011z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A37E22",
    fillOpacity: 0.17,
    d: "m25.275 10.886-.047.046-.035.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A07E25",
    fillOpacity: 0.17,
    d: "m26.317 13.585-.01.036-.047.046q.03-.04.057-.082"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A17C21",
    fillOpacity: 0.17,
    d: "m28.522 20.697.035-.011-.047.046-.035.011z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A27D22",
    fillOpacity: 0.18,
    d: "m25.193 10.942.035-.01-.047.045-.035.011z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A17D22",
    fillOpacity: 0.18,
    d: "m26.26 13.667-.047.045-.035.011z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A07B21",
    fillOpacity: 0.18,
    d: "m28.475 20.743.035-.011-.047.046-.035.011z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A27D22",
    fillOpacity: 0.18,
    d: "m25.146 10.988.035-.01-.047.045-.035.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A17D21",
    fillOpacity: 0.18,
    d: "m26.178 13.724.035-.012-.047.046-.035.011z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9F7B21",
    fillOpacity: 0.18,
    d: "m28.429 20.789.034-.012-.047.046-.034.011z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A17C22",
    fillOpacity: 0.19,
    d: "m25.1 11.034.034-.011-.047.045-.035.011z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9F7B21",
    fillOpacity: 0.18,
    d: "m28.382 20.834.035-.011-.048.045-.034.012z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A07C22",
    fillOpacity: 0.19,
    d: "m25.378 10.755-.056.086.01-.036z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "card-logo-jaywan_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 9.335h48v24H8z"
  })))));
};
export default SvgCardLogoJaywan;